module.exports = __webpack_public_path__ + "img/40222-plastic-cards-mockup 1.d6a2c1c5.png";